function toFixed (num, fixed) {
  return num.toFixed(fixed)
}

export default {
  filters: {
    round (num, { method = null, per = 100, fixed = 2 }) {
      switch (method) {
        case 'ceil':
          method = 'ceil'
          break
        case 'floor':
          method = 'floor'
          break
        default:
          method = 'round'
      }
      const result = Math[method]((+num + Number.EPSILON) * per) / per
      return toFixed(result, fixed)
    },
    roundCurrency (num) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'decimal'
      }).format(num)
    },
    toFixed (num, fixed) {
      return toFixed(num, fixed)
    }
  }
}
